import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { ILayoutState } from '../types';

export const SET_LAYOUT_PARAMS = 'LAYOUT :: SET_PARAMS';

export type TSetLayoutParamsAction = IReduxAction<typeof SET_LAYOUT_PARAMS, Partial<ILayoutState>>;

export const setLayoutParams = actionGenerator<typeof SET_LAYOUT_PARAMS, Partial<ILayoutState>>(SET_LAYOUT_PARAMS);
